import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=4891a5f2&"
import script from "./Loading.vue?vue&type=script&lang=js&"
export * from "./Loading.vue?vue&type=script&lang=js&"
import style0 from "dls-graphics/dist/separate/loading.css?vue&type=style&index=0&lang=css&"
import style1 from "veui-theme-dls/components/loading.less?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports